import React from 'react';
import { localize } from 'react-localize-redux';
import styled from 'styled-components';
import Icon, { SearchOutlined } from '@ant-design/icons';
import { AccentColor } from 'helpers/AccentColorHelper';

import { colors } from 'helpers/ColorHelper';
import CtaPrimary from 'components/ui/CtaPrimary';
import { media } from 'helpers/MediaHelper';
import { getTranslatedString } from 'helpers/i18n';

const StyledContainer = styled.div`
  position: relative;
  height: 40px;
  display: flex;
  background: ${(props) => props.bgColor || colors.DIALOG_BACKGROUND};
  ${media.mobile`
    width: 100%;
  `};
`;

const StyledIcon = styled(Icon)`
  color: ${AccentColor} !important;
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
`;

const StyledInput = styled.input`
  border-radius: 25px;
  border: none;
  background-color: #ebecf1;
  font-size: 14px;
  padding: 0 0 0 48px;
  height: 100%;
  width: 280px;
  max-width: 100%;
  &:focus {
    outline: none;
  }
  ${media.mobile`
    width: 100%;  
  `};
`;

const StyledButton = styled(CtaPrimary)`
  height: 100%;
  font-size: 12px;
  padding-top: 1px;
  padding-left: ${(props) => (props.isButtonVisible ? '15px' : '0px')};
  padding-right: ${(props) => (props.isButtonVisible ? '15px' : '0px')};
  margin-left: ${(props) => (props.isButtonVisible ? '10px' : '0px')};
  display: ${(props) => (props.isButtonVisible ? 'inline-block' : 'none')};
  width: ${(props) => (props.isButtonVisible ? '120px' : '0px')};
  transition: 0.1s ease-in;
`;

function SearchBox({
  accentColor = colors.ULTRAMARINE_BLUE,
  field,
  form,
  withButton,
  placeholder = 'Search term',
  handleChange,
  bgColor,
  translate,
  ...props
}) {
  const [isButtonVisible, setButtonVisible] = React.useState(false);

  return (
    <StyledContainer bgColor={bgColor}>
      <StyledIcon component={SearchOutlined} color={accentColor} />
      <StyledInput
        placeholder={getTranslatedString('landlordPortal.searchBox.searchTerm')}
        {...field}
        {...props}
        onChange={_handleChange}
      />
      {withButton ? (
        <StyledButton isButtonVisible={isButtonVisible} accentColor={accentColor}>
          {translate('landlordPortal.searchBox.search').props.children}
        </StyledButton>
      ) : null}
    </StyledContainer>
  );

  function _handleChange(e) {
    setButtonVisible(!!e.target.value);
    handleChange(e);
  }
}

export default localize()(SearchBox);
